import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Ordre de passage imposé sur un camion : l'API recalcule les ETA et le tracé
 * en suivant cet ordre
 */
const useReorderVehicleSteps = () => {
  const [isReordering, setIsReordering] = useState(false);

  const reorderVehicleSteps = useCallback(
    async ({ vehicleId, tourDate, orderedStepIds }) => {
      setIsReordering(true);
      try {
        const response = await fleetApi.post(
          `/tours-planning/vehicles/${vehicleId}/reorder`,
          { tour_date: tourDate, ordered_step_ids: orderedStepIds }
        );
        return response.data?.data || {};
      } catch (err) {
        throw new Error(
          err?.response?.data?.message ||
            err.message ||
            "Impossible de modifier l'ordre de passage"
        );
      } finally {
        setIsReordering(false);
      }
    },
    []
  );

  return { reorderVehicleSteps, isReordering };
};

export default useReorderVehicleSteps;
